<template>
  <CModal>
    <template #body>
      <p>{{ $t('repairOrderModal.keepJob') }}</p>
    </template>

    <template #footer>
      <CButton @click="close()" class="c-modal-cancel">
        {{ $t('general.cancel') }}
      </CButton>
      <CButton @click="submit(true)">
        {{ $t('general.yes') }}
      </CButton>
      <CButton @click="submit(false)">
        {{ $t('general.no') }}
      </CButton>
    </template>
  </CModal>
</template>

<script setup lang="ts">
  import CModal from '@/general/components/CModal.vue';
  import { BasicModalResult, MODAL_CANCELLED } from '@/general/utils/Modal';
  import CButton from '@/shared/components/buttons/CButton.vue';

  const emit = defineEmits<{ (event: 'close', result: boolean | BasicModalResult): void }>();

  async function submit(keepJob: boolean) {
    emit('close', keepJob);
  }

  function close() {
    emit('close', MODAL_CANCELLED);
  }
</script>